import { Dashboard } from '../dashboard';
import s from './dashboard-staff.module.css';
import { useDashboardStaff } from './use-dashboard-staff';

export const DashboardStaff = () => {
  const { chartsData } = useDashboardStaff();

  return <Dashboard chartsData={chartsData} dashboardsClassname={s.feature} />;
};
